<template>
  <section class="section-aesthetic animate-box">
    <div class="parallax-bg"></div>
    <div class="glass-overlay">
      <div class="content">
        <div class="brand-tag">LAIQIU PHILOSOPHY</div>
        <h3>科技，以人文的方式<span>着陆</span></h3>
        <div class="text-block">
          <p>在 0 与 1 的严密逻辑之外，我们寻找秋日般的温暖叙事。</p>
          <p>来秋社区，是极客的避风港，亦是理想主义者的共鸣腔。</p>
        </div>
        <div class="scroll-tip">
          <div class="mouse"></div>
          <span>往下看，见证灵感的生长</span>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.section-aesthetic {
  height: 70vh;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.parallax-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background-image: url('https://images.unsplash.com/photo-1507502707541-f369a3b18502?q=80&w=2000&auto=format&fit=crop');
  background-size: cover;
  background-position: center;
  z-index: -1;
  filter: brightness(0.4);
}

.glass-overlay {
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at center, transparent 0%, #050505 90%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  text-align: center;
  color: #fff;
  z-index: 1;
  padding: 0 20px;
}

.brand-tag {
  font-size: 0.8rem;
  letter-spacing: 6px;
  color: #ff9f43;
  margin-bottom: 20px;
}

.section-aesthetic h3 {
  font-size: 3.5rem;
  margin-bottom: 30px;
}

.section-aesthetic h3 span {
  font-weight: 200;
  font-style: italic;
  opacity: 0.7;
}

.text-block p {
  font-size: 1.1rem;
  opacity: 0.7;
  line-height: 2;
  letter-spacing: 1px;
}

.scroll-tip {
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  opacity: 0.4;
}

.mouse {
  width: 20px;
  height: 35px;
  border: 2px solid #fff;
  border-radius: 10px;
  position: relative;
}

.mouse::after {
  content: '';
  position: absolute;
  top: 5px;
  left: 50%;
  width: 4px;
  height: 8px;
  background: #fff;
  transform: translateX(-50%);
  border-radius: 2px;
  animation: scroll-wheel 2s infinite;
}

@keyframes scroll-wheel {
  0% {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  100% {
    opacity: 0;
    transform: translate(-50%, 15px);
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .section-aesthetic h3 {
    font-size: 2.2rem;
  }
}
</style>